import axios from 'axios'

const actions = {
  async fetchSmartSummaryOpenAI({ rootState, getters, dispatch, commit }, retryCount = 0) {
    console.log(getters.getIsFetchingSmartSummary)

    if (getters.getIsFetchingSmartSummary) return

    const url = `${rootState.base.mainApi}ai-summarizer/v1/summarize`

    commit('SET_SMART_SUMMARY', null)

    try {
      commit('SET_IS_FETCHING_SMART_SUMMARY', true)
      const response = await axios.post(url, { text: getters.getAllCardsPrompt })

      dispatch('createSmartSummary', { summary: response.data })
    } catch (error) {
      if (retryCount < 3) {
        await dispatch('fetchSmartSummaryOpenAI', { url }, retryCount + 1)
      } else {
        console.error('Failed to fetch summary after 3 attempts', error)
      }
    } finally {
      commit('SET_IS_FETCHING_SMART_SUMMARY', false)
    }
  },

  async fetchSmartSummaries({ rootState }) {
    const url = `${rootState.base.mainApi}lead/smart-summary`

    try {
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async fetchSmartSummaryById({ rootState, commit }, { id }) {
    const url = `${rootState.base.mainApi}lead/smart-summary/${id}`

    try {
      const response = await axios.get(url)

      commit('SET_SMART_SUMMARY', response.data)
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async createSmartSummary({ rootState, commit }, { summary }) {
    const url = `${rootState.base.mainApi}lead/smart-summary`

    const filters = {
      initialDate: `${rootState.base.pageFilter.dateRange[0]}`,
      finalDate: `${rootState.base.pageFilter.dateRange[1]}`,
      actions: rootState.base.pageFilter.action || null,
      csat: rootState.base.pageFilter.csat || null,
      sentiments: rootState.base.pageFilter.feeling || null
    }

    const data = {
      summary,
      filters
    }

    try {
      const response = await axios.post(url, data)

      commit('SET_SMART_SUMMARY', response.data.data)
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async setSmartSummaryLike({ rootState, getters, commit }, { like_state }) {
    const url = `${rootState.base.mainApi}lead/smart-summary/likes/${getters.getSmartSummaryId}`

    const data = {
      like_state
    }

    try {
      await axios.put(url, data)
      commit('SET_SMART_SUMMARY_LIKE', like_state)
    } catch (error) {
      console.error(error)
      return []
    }
  }
}

export default actions
